<template>
  <c-modal size="lg" title='Specify request properties' v-model="open">
    <c-form layout="horizontal">
      <div class="u-font-bold u-mb-20">Request: {{fileName}}</div>
      <c-form-field :label="propertyLabel(propertyCode)">
        <c-form-input v-model="propertyValue"></c-form-input>
      </c-form-field>
      <c-form-field>
        <c-button @click.prevent="onContinue" type="primary">Save</c-button>
      </c-form-field>
    </c-form>
  </c-modal>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'FileUploadPropertyEdit',

  data () {
    return {
      open: false,
      fileName: null,
      propertyCode: null,
      propertyValue: null,
      requestId: null,
      property: {}
    }
  },

  computed: {
    ...mapState('auth', ['clientCode']),
    ...mapGetters('client', ['propertyLabel', 'propertyIsEditable'])
  },

  methods: {
    show (requestId, fileName, propertyCode, propertyValue) {
      if (this.open) {
        return
      }

      this.fileName = fileName
      this.propertyCode = propertyCode
      this.propertyValue = propertyValue
      this.requestId = requestId

      this.open = true
    },

    onContinue () {
      // validate and save the property value
      this.$requests.updateRequestProperty(this.clientCode, this.requestId, this.propertyCode, this.propertyValue)
        .then(_ => {
          this.$emit('valueChanged', this.propertyCode, this.propertyValue)
          this.open = false
        })
        .catch(reason => {
          console.error('Could not get data')
          console.error(reason)
          this.$snotify.error('Error updating data', null, {
            position: 'centerTop',
            timeout: 3000,
            showProgressBar: false
          })
        })
    },

    onCancel () {
      this.open = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FileUploadPropertyEdit.vue